export default __webpack_public_path__ + "static/Story_Image_3_650x650px-8f2a077ccfe66fa2727f6814efbabfc4.png";